import React, { useEffect } from 'react';

const Privacy: React.FC = () => {
  useEffect(() => {
    document.title = 'WINGO World Privacy Policy';
    return () => {
      document.title = 'Wingo';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-3xl mx-auto px-4 py-10 sm:py-14">
        <article className="bg-white rounded-xl shadow-sm border border-gray-100 px-6 py-8 sm:px-10 sm:py-10 space-y-8 text-gray-700">
          <header className="space-y-2">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
              WINGO World Privacy Policy
            </h1>
            <p className="text-sm text-gray-500">
              <strong>Effective date: July 13, 2026</strong>
            </p>
            <p className="text-base leading-relaxed">
              This policy explains how the WINGO World iOS app handles information.
            </p>
          </header>

          <section className="space-y-3">
            <h2 className="text-xl font-bold text-gray-900">What the app does</h2>
            <p className="leading-relaxed">
              WINGO World is a read-only app that displays WINGO running-community information,
              including member handles, profile images, rankings, balances, ledger activity, and
              running-related summaries. The app does not require users to provide a legal name.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-bold text-gray-900">Information the app does not collect</h2>
            <p className="leading-relaxed">
              The current iOS app does not ask users to create an account, enter a legal name,
              provide payment information, upload photos, share contacts, provide precise location,
              or grant access to Apple Health or HealthKit.
            </p>
            <p className="leading-relaxed">
              The app does not display third-party advertising and does not track users across
              other companies&apos; apps or websites.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-bold text-gray-900">Technical information</h2>
            <p className="leading-relaxed">
              WINGO World uses Expo Application Services, including EAS Update, to deliver and
              maintain the app. Expo may receive limited technical information such as the device
              operating system, a randomized update token, IP address, app interactions, errors,
              and performance information.
            </p>
            <p className="leading-relaxed">
              This information is used to deliver updates, maintain security, diagnose problems,
              and improve reliability. It is not sold, used for targeted advertising, or used to
              track users across apps or websites.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-bold text-gray-900">WINGO member information</h2>
            <p className="leading-relaxed">
              The app displays information already maintained by the WINGO service. This may include
              a WINGO handle, profile image, leaderboard position, ledger activity, and
              running-related totals. Legal names are not required or displayed by the current iOS
              app.
            </p>
            <p className="leading-relaxed">
              Some member information may originate from a Strava account previously connected to
              WINGO outside the iOS app. The current iOS app does not ask users to sign in to
              Strava or grant new Strava permissions.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-bold text-gray-900">Service providers</h2>
            <p className="leading-relaxed">
              WINGO World may use service providers for app delivery, hosting, security, and
              maintenance. These providers may process limited technical information only as needed
              to provide their services.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-bold text-gray-900">Data retention and removal</h2>
            <p className="leading-relaxed">
              Technical information is retained only as reasonably necessary to operate, secure,
              and maintain the app, subject to the retention practices of the relevant service
              providers.
            </p>
            <p className="leading-relaxed">
              WINGO members may request correction or removal of information displayed in the app
              by contacting WINGO World using the phone number below.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-bold text-gray-900">Children</h2>
            <p className="leading-relaxed">
              WINGO World is not directed to children under 13 and does not knowingly collect
              personal information from children under 13.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-bold text-gray-900">Changes</h2>
            <p className="leading-relaxed">
              This policy may be updated when the app&apos;s features or data practices change. The
              effective date above will be revised when changes are posted.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-bold text-gray-900">Contact</h2>
            <p className="leading-relaxed">
              Questions, support requests, and privacy requests may be made by calling or texting:{' '}
              <a href="tel:+19299254744" className="text-wingo-600 hover:text-wingo-700 font-medium">
                929-925-4744
              </a>
            </p>
          </section>
        </article>
      </div>
    </div>
  );
};

export default Privacy;
